import { ViewBooking } from "collins-js-sdk";
import { Clock, LogOut, XCircle } from "lucide-react";
import { bookingsPreorder } from "../../../../../../../types/bookings";
import { BookingStage } from "../../../../../../../types/venues";
import {
  getBookingStageFromKey,
  getBookingStages
} from "../../../../../../../utils/booking";

export const getPreorderTotalValue = (booking: ViewBooking): string => {
  const preordersData = booking?.preorders ?? [];

  if (!booking?.hasPreorders || preordersData.length === 0) {
    return "0.00";
  }

  // Filter out deleted pre-orders (same logic as getActivePreOrders)
  const activePreOrders = preordersData.filter(
    (preOrder) =>
      !preOrder.status || (preOrder.status && preOrder.status !== "deleted")
  );

  if (activePreOrders.length === 0) {
    return "0.00";
  }

  // Calculate total from active preorders
  const preOrderTotalCost: number = activePreOrders.reduce(
    (total: number, order: bookingsPreorder) =>
      total + Number(order?.total_cost ?? 0),
    0
  );

  return (preOrderTotalCost / 100).toFixed(2);
};

export const isTouchDevice = (): boolean => {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};

export const getStageColor = (
  stageId: string,
  venueConfig: any,
  venueGroupConfig: any
): string => {
  const stages = getBookingStages({ venueConfig, venueGroupConfig });
  const stage = stages.find((s: BookingStage) => s.id === stageId);
  return stage?.colour ? `#${stage.colour}` : "#666666";
};

export const renderStageIcon = (
  currentStage: string | null | undefined,
  venueConfig: any,
  venueGroupConfig: any
) => {
  if (currentStage === "awaiting" || !currentStage) {
    return <Clock className="w-3 h-3 relative z-10" />;
  }

  if (currentStage === "left") {
    return <LogOut className="w-3 h-3 relative z-10" />;
  }

  if (currentStage === "no-show") {
    return <XCircle className="w-3 h-3 relative z-10" />;
  }

  // For all other stages, show the first letter
  const stageLabel =
    getBookingStageFromKey(
      currentStage,
      venueConfig,
      venueGroupConfig
    )?.label?.charAt(0) ?? "A";

  return <span className="relative z-10">{stageLabel}</span>;
};

export const hasRow3Content = (booking: any): boolean => {
  // Check if booking is unsaved (shows offline indicator)
  if (booking.unsaved) {
    return true;
  }

  // Check if booking has notes
  if (booking.notes && booking.notes.trim() !== "") {
    return true;
  }

  // Check if booking has special requirements
  if (
    booking.specialRequirements &&
    booking.specialRequirements.trim() !== ""
  ) {
    return true;
  }

  // Check if booking has dietary requirements
  if (
    booking.dietaryRequirements &&
    booking.dietaryRequirements.trim() !== ""
  ) {
    return true;
  }

  return false;
};
